import { Text, View } from "@react-pdf/renderer";
import ContractStyles from "../assets/styles/contractStyles";
import ContractListItem from "../constants/listItem";
import {
  LTD_COMPANY_CONTRACT_FIELD_FALLBACKS,
  LTD_COMPANY_CONTRACT_FIELD_IDS,
} from "../constants/contractFields";
import {
  formatSerialNumber,
  getChildSerialNumber,
} from "../constants/serialNumbers";

const AppointmentAndStatus = ({ contractDetails = {}, serialNumber = 3 }) => {
  const styles = ContractStyles();
  const appointmentStatuses = "Financial Planning Consultant, Mortgage and Protection Appointed Representative or General Insurance Appointed Representative as"
    // contractDetails.appointmentStatuses?.filter(Boolean).join(" or ") ||
    // LTD_COMPANY_CONTRACT_FIELD_FALLBACKS.appointmentStatuses;

  return (
    <View style={[styles.flexColumn, styles.gap_sm]}>
      <ContractListItem
        id="appointment-and-status"
        marker={formatSerialNumber(serialNumber)}
        styles={styles}
        textStyle={[styles.contentSemibold, styles.text_primary]}
      >
        Appointment and Status
      </ContractListItem>

      <View style={[styles.flexColumn, styles.gap_sm, ]}>
        <ContractListItem
          marker={getChildSerialNumber(serialNumber, 0)}
          markerWidth={24}
          styles={styles}
          textStyle={styles.buttonTextSmall}
        >
          Subject at all times to the approval of the Company, the Appointed
          Representative will work as a{" "}
          <Text
            id={LTD_COMPANY_CONTRACT_FIELD_IDS.appointmentStatuses}
            style={styles.text_red}
          >
            {appointmentStatuses}
          </Text>{" "}
          a representative of the Company for the purpose only of carrying on
          the business.
        </ContractListItem>

        <ContractListItem
          marker={getChildSerialNumber(serialNumber, 1)}
          markerWidth={24}
          styles={styles}
          textStyle={styles.buttonTextSmall}
        >
          The Appointed Representative is not permitted to represent other
          counterparties or to carry on any other regulated activity or to
          promote, sell or advise on any financial services or plans without the
          express written consent of the Company, but may make introductions to
          Independent Financial Appointed Representatives as permitted by the
          Company from time to time.
        </ContractListItem>

        <ContractListItem
          marker={getChildSerialNumber(serialNumber, 2)}
          markerWidth={24}
          styles={styles}
          textStyle={styles.buttonTextSmall}
        >
          The Appointed Representative warrants to the Company that they shall
          undertake the Sales Activities with reasonable skill and care and in
          accordance with the rules and regulations set out by the Company and
          the FCA.
        </ContractListItem>
      </View>
    </View>
  );
};

export default AppointmentAndStatus;
